import React, {useEffect, useRef, useState} from 'react';
import './event-details.scss';
import TaskInfo from './task-info';
import {Form, Formik} from 'formik';
import ProtectiveMeasure from './protective-measure';
import UnwantedEvent from './unwanted-event';
import Status from './status';
import Button from '../../../../../components/form/button/button';
import ControlSystem from './control-syste';
import RiskLowered from './risk-lowered';
import FinalRecommendation from './final-recommendation';
import ActionRequired from './action-require';
import EventAction from './event-action';
import {useDispatch} from 'react-redux';
import * as Yup from 'yup';
import {
  enumStatusId,
  eventDetailInfoIconEnum,
  EventStatusEnum,
  EventStatusIds,
  getUserRoleName,
  likelihoodUnwantedEventEnum,
  parseEventStatusForForm,
  severityUnwantedEventEnum,
  statusEnum,
  statusTypes,
  statusValues,
} from '../../../../../utils/constants';
import {
  getEventDetail,
  saveEventDetail,
  updateEventDetail,
  uploadMedia,
} from '../../../../../redux/risk-assessment-core/riskAssessmentCoreSlice';
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';
import {allRoutes} from '../../../../../utils/routeConstants';
import Loader from '../../../../../components/loader/loader';
import {useSelector} from 'react-redux';
import {
  getEventDetailState,
  getRiskAssessmentCoreLoadingState,
} from '../../../../../redux/selectors/riskAssessmentCore';
import TaskMedia from '../task-details/task-media/task-media';
import {getLoginStateSelector} from '../../../../../redux/selectors/loginSelector';
import {toast} from 'react-toastify';
import SingleSelectDropdown from '../../../../../components/form/singleSelectDropdown/singleSelectDropdown';
import CustomSelect from '../../../../../components/form/customSelect/customSelect';
import FailureMode from './failure-mode';

function idFromSearchParams(searchParams, key) {
  const raw = searchParams.get(key);
  if (raw == null || raw === '') {
    return undefined;
  }
  const n = Number(raw);
  return Number.isFinite(n) ? n : undefined;
}

const EventDetail = () => {
  const loginState = useSelector(getLoginStateSelector());
  const {loggedInUser} = loginState;
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentNavState = location.state;
  const selectedRiskAssessment = currentNavState?.selectedRiskAssessment;
  const eventIdFromState = currentNavState?.eventId;
  const selectedTask = currentNavState?.selectedTask;
  const selectedEventName = currentNavState?.selectedEventName;
  const nav = useNavigate();

  const eventId =
    idFromSearchParams(searchParams, 'eventMappingId') ?? eventIdFromState;
  const riskAssessmentIdFromState =
    typeof selectedRiskAssessment === 'object' &&
    selectedRiskAssessment != null &&
    selectedRiskAssessment.id != null
      ? selectedRiskAssessment.id
      : undefined;
  const effectiveRiskAssessmentId =
    idFromSearchParams(searchParams, 'riskAssessmentId') ??
    riskAssessmentIdFromState;

  useEffect(() => {
    const next = new URLSearchParams(location.search);
    let changed = false;
    if (eventIdFromState != null && !next.get('eventMappingId')) {
      next.set('eventMappingId', String(eventIdFromState));
      changed = true;
    }
    if (riskAssessmentIdFromState != null && !next.get('riskAssessmentId')) {
      next.set('riskAssessmentId', String(riskAssessmentIdFromState));
      changed = true;
    }
    if (changed) {
      setSearchParams(next, {replace: true});
    }
  }, [
    eventIdFromState,
    riskAssessmentIdFromState,
    location.search,
    setSearchParams,
  ]);
  const isLoading = useSelector(getRiskAssessmentCoreLoadingState());
  //const eventDetail = useSelector(getEventDetailState())
  const [eventDetail, setEventDetail] = useState();
  const [showTaskMedia, setShowTaskMedia] = useState(false);
  const [eventMedia, setEventMedia] = useState([]);
  const [statusLabel, setStatusLabel] = useState('');
  const [likelihoodId, setLikelihoodId] = useState();
  const [severityId, setSeverityId] = useState();
  const [protectiveMeasuresHeight, setProtectiveMeasuresHeight] = useState(0);


  const [readOnly, setReadOnly] = useState(
    getUserRoleName(loggedInUser?.role) === 'general',
  );
  const eventDetailFetchSeq = useRef(0);

  useEffect(() => {
    if (eventId) {
      fetchEventDetail();
    }
  }, [eventId, effectiveRiskAssessmentId]);
  useEffect(() => {
    // setStatusLabel(statusValues[eventDetail?.likelihood_unwanted_event??"2"][eventDetail?.severity_unwanted_event??"1"])
    setStatusLabel(statusTypes[eventDetail?.risk_ranking_consideration]);
    setLikelihoodId(
      eventDetail?.likelihood_unwanted_event == 1
        ? 2
        : eventDetail?.likelihood_unwanted_event,
    );
    setSeverityId(eventDetail?.severity_unwanted_event);
  }, [eventDetail]);
  const fetchEventDetail = () => {
    const seq = ++eventDetailFetchSeq.current;
    const payload = {
      eventId: eventId,
      parentRiskAssessmentId: effectiveRiskAssessmentId,
      config: {},
    };
    dispatch(
      getEventDetail({
        payload,
        callback: resp => {
          if (seq !== eventDetailFetchSeq.current) {
            return;
          }
          setEventDetail(resp);
          setEventMedia(resp?.media_details ?? []);
        },
      }),
    );
  };

  const initialValues = {
    inherently_measures: eventDetail?.inherently_measures ?? '',
    safeguarding: eventDetail?.safeguarding ?? '',
    info_for_use: eventDetail?.info_for_use ?? '',
    cntrl_hazard: eventDetail?.cntrl_hazard ?? 0,
    cntrl_motion: eventDetail?.cntrl_motion ?? 0,
    safety_note: eventDetail?.safety_note ?? '',
    // likelihood_unwanted_event: eventDetail?.likelihood_unwanted_event
    //   ? likelihoodUnwantedEventEnum.find(
    //       item => item.id == eventDetail?.likelihood_unwanted_event
    //     )??likelihoodUnwantedEventEnum[0]
    //   : likelihoodUnwantedEventEnum[0],
    likelihood_unwanted_event: likelihoodUnwantedEventEnum.find(
      item => item.id == eventDetail?.likelihood_unwanted_event,
    ),
    likelihood_note: eventDetail?.likelihood_note ?? '',
    severity_unwanted_event: severityUnwantedEventEnum.find(
      item => item.id == eventDetail?.severity_unwanted_event,
    ),
    // severity_unwanted_event: eventDetail?.severity_unwanted_event
    //   ? severityUnwantedEventEnum.find(
    //       item => item.id == eventDetail?.severity_unwanted_event,
    //     )
    //   : severityUnwantedEventEnum[0],
    severity_note: eventDetail?.severity_note ?? '',
    risk_ranking_consideration: eventDetail?.risk_ranking_consideration
      ? statusEnum.find(
          item => item.id == eventDetail?.risk_ranking_consideration,
        )
      : statusEnum[0],
    risk_ranking_note: eventDetail?.risk_ranking_note ?? '',
    risk_low_accpt_level: eventDetail?.risk_low_accpt_level ?? 0,
    risk_low_accpt_level_note: eventDetail?.risk_low_accpt_level_note ?? '',
    additional_hazards: eventDetail?.additional_hazards ?? 0,
    new_task: eventDetail?.new_task ? [...eventDetail?.new_task] : [],
    internal_note: eventDetail?.internal_note ?? '',
    final_note: eventDetail?.final_note ?? '',
    action_required_by: eventDetail?.action_required_by
      ? [...eventDetail?.action_required_by]
      : [],

    action_required_text: eventDetail?.action_required_text ?? '',
    event_status: parseEventStatusForForm(eventDetail?.event_status),
    removed_notes: eventDetail?.removed_notes ?? '',
    // assessed_by: null,
    parent_risk_assessment: effectiveRiskAssessmentId,
    event_task: eventId,
  };

  const validate = Yup.object({
    action_required_by: Yup.array().nullable(),
    event_status: Yup.number().nullable(),
  });

  const handleSubmit = (vals, {setFieldError}, toGoBack = true) => {
    // if (
    //   vals.event_status &&
    //   (!vals.action_required_by || vals.action_required_by.length === 0)
    // ) {
    //   setFieldError(
    //     'action_required_by',
    //     'Action is required when event status is filled',
    //   );
    // } else {
      const payload = {...vals};
      payload.likelihood_unwanted_event = vals.likelihood_unwanted_event?.id;
      payload.severity_unwanted_event = vals.severity_unwanted_event?.id;
      payload.risk_ranking_consideration = enumStatusId[statusLabel];
      payload.media = eventMedia?.map(media => media.id);
      // payload.action_required_by = [vals.action_required_by];

      try {
        if (eventDetail?.id) {
          dispatch(
            updateEventDetail({
              id: eventDetail?.id,
              payload,
              callback: () => onSuccess(toGoBack),
            }),
          );
        } else {
          dispatch(
            saveEventDetail({
              payload,
              callback: () => onSuccess(toGoBack),
            }),
          );
        }
      } catch (error) {
        toast.error('Unable to save the task. Please try again.', {
          autoClose: 2000,
          className: 'toast-error',
        });
      }
    // }
  };

  const onSuccess = toGoBack => {
    if (toGoBack) {
      goBack();
      toast.success('Task successfully saved.', {
        autoClose: 2000,
        className: 'toast-success',
      });
    }

    fetchEventDetail();
  };

  const goBack = () => {
    nav(allRoutes.dashboardRoutes.assessmentRoutes.taskDetails, {
      state: location.state,
    });
  };

  const handleMediaAdd = e => {
    const files = Array.from(e.target.files);
    const payload = new FormData();
    files.forEach(file => {
      payload.append('media', file);
    });
    dispatch(
      uploadMedia({
        payload,
        callback: resp => {
          setEventMedia([...eventMedia, ...resp]);
        },
      }),
    );
  };

  useEffect(() => {
    if (likelihoodId && severityId)
      setStatusLabel(statusValues[likelihoodId][severityId]);
  }, [likelihoodId, severityId]);

  const onHandleChange = (name, val) => {
    {
      name === 'likelihood_unwanted_event'
        ? setLikelihoodId(val)
        : setSeverityId(val);
    }
  };

  const handleProtectiveMeasuresHeight = height => {
    setProtectiveMeasuresHeight(height);
  };


  const handleDeleteMedia=(media)=>{
    setEventMedia(eventMedia.filter((item)=>item?.id!==media?.id));
  }

  return (
    <div className="event-details-wrapper">
      <header>
        <TaskInfo
          handleMediaAdd={handleMediaAdd}
          setShowTaskMedia={setShowTaskMedia}
          readOnly={readOnly}
        />
      </header>
      {location.state?.type === 1 && eventDetail ? (
        <div className="event-info-wrapper">
          <Formik
            initialValues={initialValues}
            validationSchema={validate}
            onSubmit={handleSubmit}>
            {({
              formik,
              values,
              setFieldValue,
              isSubmitting,
              isValid,
              errors,
              setFieldError,
            }) => (
              <Form>
                <ProtectiveMeasure
                  readOnly={readOnly}
                  setProtectiveMeasuresHeight={handleProtectiveMeasuresHeight}
                  setFieldValue={setFieldValue}
                  values={values}
                />

                <div
                  className="heading"
                  style={{marginTop: `${protectiveMeasuresHeight}px`}}>
                  Functional safety:
                </div>
                <ControlSystem
                  setFieldValue={setFieldValue}
                  values={values}
                  showInfoIcon={false}
                  readOnly={readOnly}
                />
                <UnwantedEvent
                  setFieldValue={setFieldValue}
                  name={'likelihood_unwanted_event'}
                  title={'Likelihood of potential unwanted event'}
                  description={
                    likelihoodId
                      ? `'The team has determined that based on the inherently safe design measures, safeguarding, and information for use, the likelihood of "${selectedEventName}" during "${selectedTask.name}" is ${values['likelihood_unwanted_event']?.name}'`
                      : ''
                  }
                  placeholder={'Select Option'}
                  items={likelihoodUnwantedEventEnum}
                  noteName={'likelihood_note'}
                  values={values}
                  showInfoIcon={true}
                  infoIconLabel={eventDetailInfoIconEnum.likelihood}
                  onHandleChange={onHandleChange}
                  readOnly={readOnly}
                />
                <UnwantedEvent
                  setFieldValue={setFieldValue}
                  name={'severity_unwanted_event'}
                  title={'Worst credible severity of potential unwanted event'}
                  description={
                    severityId
                      ? `'The team has determined that based on the inherently safe design measures, safeguarding, and information for use, the worst credible severity of "${selectedEventName}" during "${selectedTask.name}" is ${values['severity_unwanted_event'].name}'`
                      : ''
                  }
                  placeholder={'Select Option'}
                  items={severityUnwantedEventEnum}
                  noteName={'severity_note'}
                  values={values}
                  showInfoIcon={true}
                  infoIconLabel={
                    eventDetailInfoIconEnum.worst_credible_severity
                  }
                  onHandleChange={onHandleChange}
                  readOnly={readOnly}
                />

                <Status
                  setFieldValue={setFieldValue}
                  values={values}
                  statusValues={statusLabel}
                  showInfoIcon={false}
                  readOnly={readOnly}
                />
                <RiskLowered
                  setFieldValue={setFieldValue}
                  values={values}
                  showInfoIcon={true}
                  eventName={selectedEventName}
                  taskName={selectedTask.name}
                  readOnly={readOnly}
                />

                <FinalRecommendation
                  setFieldValue={setFieldValue}
                  values={values}
                  readOnly={readOnly}
                />
                <ActionRequired
                  setFieldValue={setFieldValue}
                  actionRequireValue={values.action_required_by}
                  readOnly={readOnly}
                  errors={errors}
                  eventId={eventId}
                  values={values}
                  handleUpdateData={vals =>
                    handleSubmit(vals, {setFieldError}, false)
                  }
                  eventStatus={values['event_status']}
                  setFieldError={setFieldError}
                  riskAssessmentId={effectiveRiskAssessmentId}
                  eventName={selectedEventName}
                  taskName={selectedTask?.name}
                  riskAssessmentName={selectedRiskAssessment?.name}
                  modelName={selectedRiskAssessment?.machine_detail?.map(el => el.name).join(', ')}
                  productLineName={selectedRiskAssessment?.product_detail?.name}
                />

                <CustomSelect
                  // label={'Select Status'}
                  label={'Event has been'}
                  options={EventStatusEnum}
                  // options={[...EventStatusEnum,{label:"None",value:null}]}
                  name={'event_status'}
                  value={values['event_status']}
                  handleChange={e => {
                    const v = e.target.value;
                    setFieldValue(
                      'event_status',
                      v === '' ? EventStatusIds.NotStarted : Number(v),
                    );
                  }}
                  showError={true}
                  disabled={readOnly}
                  // error={errors["action_required_by"]??""}
                />

                {/* <EventAction
                  setFieldValue={setFieldValue}
                  eventStatus={values.event_status}
                  noteValue={values.removed_notes}
                  readOnly={readOnly}
                /> */}

                {errors['action_required_by'] && (
                  <p style={{color: 'red', padding: '10px'}}>
                    {errors['action_required_by']}
                  </p>
                )}
                {!readOnly && (
                  <div className="action-buttons mt-3">
                    <Button type="submit" variant="submit-button">
                      Save
                    </Button>
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </div>
      ) : (
        <FailureMode
          key={`${eventId}-${effectiveRiskAssessmentId ?? ''}`}
          eventId={eventId}
          riskAssessmentId={effectiveRiskAssessmentId}
          eventDetail={eventDetail}
          fetchEventDetail={fetchEventDetail}
          readOnly={readOnly}
        />
      )}

      {isLoading && <Loader />}
      {showTaskMedia && (
        <TaskMedia
          medias={eventMedia}
          show={showTaskMedia}
          setShow={() => setShowTaskMedia(false)}
          handleDelete={handleDeleteMedia}
        />
      )}
    </div>
  );
};

export default EventDetail;
